import { FC } from 'react';
import { TimerState } from '../../../../hooks/useTimer';

type Props = {
  timerState: TimerState;
  remainingSecondsToClose: number;
};
const ForceExitTimer: FC<Props> = ({ timerState, remainingSecondsToClose }) => {
  const color = (() => {
    if (timerState === 'forceExitPhase1') {
      return '#e9ec46';
    } else if (timerState === 'forceExitPhase2') {
      return '#FF0000';
    } else {
      return '';
    }
  })();

  return (
    <>
      {timerState === 'forceExitPhase1' || timerState === 'forceExitPhase2' ? (
        <div style={{ fontSize: '18px', fontWeight: 'bold', color: color }}>
          {'後 '} {remainingSecondsToClose} {' 秒で終了します。'}
        </div>
      ) : null}
    </>
  );
};
export default ForceExitTimer;
